<template>
  <div>
    <div
        class="top_img"
        :style="{
        'background-image':  `url(${topBannerData.img})`
      }"
    >
      <p class="title" v-if="$i18n.locale === 'zh'">{{ topBannerData.titleZh }}</p>
      <p class="title" v-else-if="$i18n.locale === 'es'">{{ topBannerData.titleEs || topBannerData.titleEn }}</p>
      <p class="title" v-else>{{ topBannerData.titleEn }}</p>

      <p class="subtitle" v-if="$i18n.locale === 'zh'">{{ topBannerData.contentZh }}</p>
      <p class="subtitle" v-else-if="$i18n.locale === 'es'">{{ topBannerData.contentEs || topBannerData.contentEn }}</p>
      <p class="subtitle" v-else>{{ topBannerData.contentEn }}</p>
    </div>


    <!-- 面包屑和分类导航 -->
    <div class="nav_container">
      <div class="breadcrumb_section">
        <div class="breadcrumb_content">
          <span @click="$router.push('/')">{{ $t("Home") }}</span>
          <span class="separator">></span>
          <span class="current">{{ $t("News Updates") }}</span>
        </div>
      </div>
      <div class="page_nav_div">
        <p
            :class="type == i + 1 ? 'active' : ''"
            v-for="(item, i) in newsNavList"
            :key="i"
            @click="navItemClick(i)"
        >
          {{ item.title }}
        </p>
      </div>
    </div>
    <div class="news_div">
      <el-carousel v-if="carouselList.length > 0" arrow="never" interval="5000">
        <el-carousel-item v-for="(item, index) in carouselList" :key="item.id">
          <div class="top_news_div" @click="pushTo('/NewsDetail/id=' + item.id)">
            <div class="img_div">
              <img :src="item.img"/>
            </div>
            <div class="top_news_div_right">
              <p class="top_news_time">{{ item.time }}</p>
              <p class="top_news_title double-line">
                {{ getLocalizedField(item, 'title') }}
              </p>
              <p class="top_news_content double-line">
                {{ getLocalizedField(item, 'simple') }}
              </p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <el-row class="sub_news_div" :gutter="20">
        <el-col
            :md="24"
            v-for="(item, i) in list"
            :key="i"
        >
          <div
              class="news_sub_box"
              @click="pushTo('/NewsDetail/id=' + item.id)"
          >
            <div class="bottom_content">
              <div class="news_sub_time_wrapper">
                <p class="news_sub_time_full">{{ item.time.split('-')[2] }}</p>
                <p class="news_sub_time_short">{{ item.time.substring(0, 7) }}</p>
              </div>
              <div class="news_sub_text">
                <p class="news_sub_title double-line">
                  {{ getLocalizedField(item, 'title') }}
                </p>
                <p class="news_sub_content double-line">
                  {{ getLocalizedField(item, 'simple') }}
                </p>
              </div>
            </div>
            <div class="top_div">
              <div class="img_div">
                <img :src="item.img"/>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-pagination
          class="page_div"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCount"
      >
      </el-pagination>
      <!--      <p class="more" @click="loadMore()">{{ $t("加载更多") }}</p>-->
    </div>
  </div>
</template>
<script>
import * as API from "@/api/index";
import * as navBar from "./navbar/navbar";

export default {
  components: {},
  data() {
    return {
      list: [],
      carouselList: [],
      currentPage: 1,
      totalCount: 0,
      totalPage: 1,
      pageSize: 10,
      type: 1, //新闻类型 1:公司新闻 2:行业新闻
      isMiniWindows: false,
      clientWidth: 0,
      contactData: {},
      topBannerData: {}
    };
  },
  watch: {
    clientWidth(newVal, oldVal) {
      // console.log(newVal); //浏览器窗口变化时，打印宽度。
      if (newVal < 1200) {
        this.isMiniWindows = true;
      } else {
        this.isMiniWindows = false;
      }
    },
    $route(to, from) {
      if (to.path.indexOf("/News") != -1) {
        var param = this.$route.query.param;
        if (param) {
          console.log("News param:" + param);
          const nextType = parseInt(param);
          if (nextType !== this.type) {
            this.type = nextType;
            this.currentPage = 1;
            this.getList(true);
            return;
          }
        }
        this.getList(this.carouselList.length === 0);
      }
    },
  },
  created() {
  },
  computed: {
    nav_title() {
      return navBar.getList();
    },
    newsNavList() {
      const list = navBar.getList();
      const newsItem = list.find(item => item.path === '/News');
      return newsItem ? newsItem.children : [];
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getTopBannerData();
    // this.getContactUsData();
    this.getList(true);
    let that = this;
    var clientWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    window.onresize = () => {
      return (() => {
        var clientWidth =
            document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },
  methods: {
    // 获取顶部Banner数据
    getTopBannerData() {
      API.getTopImgsByRemark('新闻')
          .then((res) => {
            console.log('topBannerData res', res);
            if (res.code === 0 && res.topImgs) {
              this.topBannerData = res.topImgs;
            }
          })
          .catch(() => {
          });
    },
    // 获取联系我们信息
    getContactUsData() {
      API.getContactUsList({page: 1, limit: 1})
          .then((res) => {
            if (res.code === 0 && res.page && res.page.list && res.page.list.length > 0) {
              const data = res.page.list[0];
              this.contactData = {
                topImage: data.topImage || "",
                topTitleCn: data.topTitleCn || "",
                topTitleEn: data.topTitleEn || "",
                topTitleEs: data.topTitleEs || ""
              };
            }
          })
          .catch(() => {
          });
    },
    pushTo(path) {
      this.$router.push(path);
    },
    navItemClick(index) {
      this.type = index + 1;
      let url = this.changeURLParam(window.location.href, "param", this.type);
      console.log("url", url);
      history.pushState("", "", url);
      this.currentPage = 1;
      this.getList(true);
    },
    changeURLParam(url, type, value) {
      let reg = eval("/([?|&]" + type + "=)[^&]*/gi");
      value = value.toString().replace(/(^\s*)|(\s*$)/g, "");
      let url2;
      if (!value) {
        url2 = url.replace(reg, "");
      } else {
        if (url.match(reg)) {
          url2 = url.replace(reg, "$1" + value);
        } else {
          url2 = url + (url.indexOf("?") > -1 ? "&" : "?") + type + "=" + value;
        }
      }
      return url2;
    },
    loadMore() {
      this.currentPage++;
      this.getList(false);
    },
    // 获取多语言字段
    getLocalizedField(item, field) {
      if (!item) return '';
      if (this.$i18n.locale === 'zh') {
        return item[field + 'Cn'] || item[field];
      } else if (this.$i18n.locale === 'es') {
        return item[field + 'Es'] || item[field + 'En'] || item[field + 'Cn'] || item[field];
      }
      return item[field + 'En'] || item[field + 'Cn'] || item[field];
    },
    getList(refreshCarousel = false) {
      // 根据类型获取企业新闻或行业新闻
      const apiCall = this.type == 1 ? API.getNewsCompanyList : API.getNewsIndustryList;
      const params = {
        page: this.currentPage,
        limit: this.pageSize,
      };

      apiCall(params)
          .then((res) => {
            if (res.code === 0 && res.page) {
              // 处理新闻数据
              const newsList = res.page.list.map(item => ({
                id: item.id,
                title: this.$getI18nField(item, 'title'),
                simple: this.$getI18nField(item, 'summary'),
                img: item.image,
                time: item.publishDate || (item.createTime ? item.createTime.split(' ')[0] : ''),
                typeName: this.type == 1 ?
                  (this.$i18n.locale === 'zh' ? '公司新闻' : this.$i18n.locale === 'es' ? 'Noticias de la Empresa' : 'Company News') :
                  (this.$i18n.locale === 'zh' ? '行业动态' : this.$i18n.locale === 'es' ? 'Noticias de la Industria' : 'Industry News')
              }));

              if (refreshCarousel) {
                this.carouselList = newsList.slice(0, 3);
              }
              this.list = newsList;
              this.currentPage = res.page.currPage;
              this.pageSize = res.page.pageSize || this.pageSize;
              this.totalCount = res.page.totalCount || 0;
              this.totalPage = res.page.totalPage || 1;
            }
          })
          .catch(() => {
          });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getList(false);
    },
  },
};
</script>
<style lang="scss" scoped>
// 面包屑导航
.breadcrumb_section {
  background: white;
  padding: 3rem 0 0;
  width: 50%;

  .breadcrumb_content {
    max-width: 140rem;
    margin: 0 auto;
    padding: 0 2rem;
    font-size: 1.8rem;
    color: #BDC0C5;
    text-align: left;
    font-family: regular;

    span {
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1d2087;
      }

      &.separator {
        margin: 0 1rem;
        color: #BDC0C5;
        cursor: default;
      }

      &.current {
        color: #1D2087;
        cursor: default;
      }
    }
  }
}

/deep/ .el-carousel__container {
  margin-top: 7rem;
  height: 46rem;
}

/deep/ .el-carousel__indicators--horizontal {
  bottom: 5rem;
  left: 57%;
  transform: translateX(-75%);
}

/deep/ .el-carousel__indicator .el-carousel__button {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: #BDC0C5;
}

/deep/ .el-carousel__indicator.is-active .el-carousel__button {
  background-color: #5B6370;
}

.nav_container {
  display: flex;
  background: white;
  border-bottom: 1px solid #BDC0C5;
  padding: 0 12.5% 0;
}

.total_margin_div {
  max-width: 144rem;
}

/deep/ .el-pager li.active {
  color: $textMainColor;
}

/deep/ .el-pager li:hover {
  color: $textMainColor;
}

.news_div {
  padding: 8rem 2rem;
  max-width: 140rem;
  margin-left: auto;
  margin-right: auto;
}

.top_img {
  padding: 0 12.5%;
  height: 47rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .title {
    text-align: left;
    font-size: 7rem;
    font-family: bold;
    color: white;
    margin: 7rem 0 0 0;
    align-self: flex-start;
  }

  .subtitle {
    text-align: left;
    font-size: 2rem;
    color: rgba(255, 255, 255, 0.7);
    margin-top: 1rem;
    letter-spacing: 1rem;
  }
}

.top_news_div {
  background: white;
  display: flex;
  //box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  .img_div {
    width: 50%;
    overflow: hidden;
    max-height: 46rem;
    border-radius: 1.6rem;
  }

  img {
    cursor: pointer;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all ease 0.4s;
  }

  .top_news_div_right {
    cursor: pointer;
    width: 50%;
    padding: 0 0 0 13.7rem;
    display: flex;
    flex-direction: column;

    .top_news_title {
      font-size: 5rem;
      color: $textMainColor;
      font-family: bold;
      line-height: 1.3;
      text-align: start;
      margin-bottom: 3rem;
    }

    .top_news_content {
      margin: 2.5rem 0 3.5rem;
      text-align: start;
      font-size: 2.2rem;
      font-family: regular;
      margin-bottom: 3rem;
      line-height: 2.8rem;
      color: #666;
    }

    .top_news_type {
      text-align: start;
      font-size: 1.4rem;
      color: $textMainColor;
      background: $colorF6F6F7;
      padding: 2px 1.4rem;
    }

    .top_news_time {
      text-align: start;
      font-size: 1.8rem;
      //margin-left: 1.3rem;
      color: #999;
      margin-bottom: 3rem;
      font-family: regular;
    }
  }

  &:hover {
    img {
      //transform: scale(1.1);
      //transition: all ease 0.4s;
    }

    .top_news_title {
      color: $textMainColor;
    }
  }
}

.sub_news_div {
  margin-top: 15rem;
}

.news_sub_box {
  cursor: pointer;
  background-color: white;
  //box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  margin-bottom: 6rem;
  display: flex;

  .bottom_content {
    width: 100%;
    max-width: 70%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #656565;
  }

  .top_div {
    width: 50%;
    transition: all 0.5s;
    height: 22.6rem;
    background-color: white;
    display: flex;
    justify-content: flex-end;
  }

  .img_div {
    overflow: hidden;
    width: 35rem;
    height: 22.6rem;
    border-radius: 1.6rem;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.5s;
  }

  .bottom_content {
    padding: 0;
    display: flex;
    flex-direction: row;

    p {
      text-align: start;
    }

    .news_sub_title {
      font-size: 3.2rem;
      font-family: bold;
      color: #5B6370;
      margin: 0 0 1.2rem 0;
    }

    .news_sub_content {
      font-size: 2.2rem;
      margin-bottom: 0;
      line-height: 2.5rem;
      color: #5B6370;
      font-family: regular;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .news_sub_type {
      font-size: 1.4rem;
      margin-right: 1.3rem;
      color: $textMainColor;
      background: $colorF6F6F7;
      padding: 2px 1.4rem;
    }

    .news_sub_time_wrapper {
      display: flex;
      flex-direction: column;
      margin-bottom: 4.5rem;
      width: auto;
      justify-content: flex-end;
    }

    .news_sub_text {
      width: 70%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-left: 6rem;
      margin-bottom: 4.5rem;
    }

    .news_sub_time_full {
      font-size: 5.5rem;
      color: #5B6370;
      margin: 0;
      transition: color 0.3s;
      font-family: regular;
    }

    .news_sub_title {
      transition: color 0.3s;
    }

    &:hover {
      .news_sub_time_full,
      .news_sub_title {
        color: #9CCF86;
      }
    }

    .news_sub_time_short {
      font-size: 1.8rem;
      color: #8A9099;
      margin: 0;
    }
  }

  &:hover {
    //box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
    //transition: all 0.3s;

    img {
      //transform: scale(1.1);
      //transition: all ease 0.5s;
    }

    .bottom_content {
      .news_sub_title {
        color: $textMainColor;
      }
    }
  }
}

.page_div {
  display: block;
  margin: 10rem 0;
}

.more {
  display: none;
  position: relative;
  cursor: pointer;
  color: white;
  border: $textMainColor solid 1px;
  background: $textMainColor;
  font-size: 1rem;
  padding: 0.7rem 2.3rem;
  width: fit-content;
  transition: all 0.5s;
  box-sizing: border-box;
  margin: 7rem auto 10rem;
  // margin: 4.7rem auto 0;
  &::after {
    content: "";
    width: 1rem;
    height: 1rem;
    background: url("../../static/img/news_arrow_down.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    // position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0 auto 0.5rem;
  }

  &:hover {
    transition: all 0.5s;
    color: white;
    border: $textMainColor solid 1px;
    background: $textMainColor;

    &::after {
      content: "";
      background: url("../../static/img/news_arrow_down.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}

@media (max-width: 1200px) {
  .top_img {
    height: 30rem;

    .title {
      font-size: 3.5rem;
    }

    .subtitle {
      font-size: 1.4rem;
      letter-spacing: 0.5rem;
    }
  }

  .page_nav_div {
    width: 50%;
    flex-wrap: wrap;
    padding: 1rem;
    display: flex;
    justify-content: flex-end;

    p {
      padding: 1rem 1.5rem;
      font-size: 1.4rem;
    }
  }

  .news_div {
    padding: 4rem 1.7rem;
  }
  .top_news_div {
    margin-top: 2rem;
    flex-direction: column;

    .img_div {
      width: 100%;
      height: 22.8rem;
    }

    .top_news_div_right {
      width: 100%;
      padding: 1rem 0;
      background: white;

      .top_news_title {
        font-size: 1.5rem;
        line-height: 1.9rem;
      }

      .top_news_content {
        font-size: 1.1rem;
        line-height: 1.7rem;
        margin: 0.6rem 0 1.8rem;
      }

      .top_news_time {
        font-size: 1rem;
        margin-left: 0;
      }

      .top_news_type {
        font-size: 1rem;
      }
    }
  }
  .sub_news_div {
    margin-top: 0;
  }
  .news_sub_box {
    margin-top: 2rem;

    .top_div {
      height: 22.8rem;
    }

    .img_div {
      height: 22.8rem;

      img {
        height: 100%;
      }
    }

    .bottom_content {
      margin: 0;
      padding: 1rem 0;

      .news_sub_title {
        margin: 0;
        font-size: 1.5rem;
        line-height: 1.9rem;
      }

      .news_sub_content {
        font-size: 1.1rem;
        line-height: 1.7rem;
        margin: 0.6rem 0 1.8rem;
      }

      .news_sub_time {
        font-size: 1rem;
      }

      .news_sub_type {
        font-size: 1rem;
        margin-right: 0;
      }
    }
  }
  .page_div {
    display: none;
  }
  .more {
    display: block;
  }
}

@media (max-width: 768px) {
  .top_img {
    padding: 0 2rem;
    height: 30rem;
    display: flex;

    .title {
      font-size: 3rem;
      margin: 5rem 0 0 0;
    }

    .subtitle {
      font-size: 1.4rem;
      margin-top: 1rem;
    }
  }

  .nav_container {
    padding: 0;
    display: flex;
  }

  .breadcrumb_section {
    display: none;
    padding: 2rem 0 0;

    .breadcrumb_content {
      padding: 0 1rem;
      font-size: 1.4rem;
    }
  }

  .page_nav_div {
    width: 100% !important;
    padding: 0 !important;
    justify-content: center !important;
    display: flex;

    p {
      padding: 0.8rem 1.2rem;
      font-size: 1.2rem;
    }
  }

  .news_div {
    padding: 1rem 2rem !important;
  }

  /deep/ .el-carousel__container {
    margin-top: 0;
    height: 40rem !important;
  }
  /deep/ .el-carousel__indicators--horizontal {
    bottom: 0;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  .top_news_div {
    display: flex;

    .img_div {
      height: 18rem;
    }

    .top_news_div_right {
      margin-top: 1rem;
      padding: 0 ;

      .top_news_title {
        font-size: 2.5rem !important;
        line-height: 1.5 !important;
        margin-bottom: 0.5rem !important;
      }

      .top_news_content {
        font-size: 1.6rem !important;
        line-height: 2rem !important;
        margin: 1rem 0 1.5rem !important;
      }

      .top_news_time {
        font-size: 1.4rem !important;
        margin-bottom: 1rem !important;
      }
    }
  }

  .sub_news_div {
    margin-top: 3rem;
  }

  .news_sub_box {
    margin-bottom: 3rem;
    display: flex;
    justify-content: space-between !important;

    .bottom_content {
      display: flex;
      width: 60% !important;

      .news_sub_time_wrapper {
        margin-bottom: 0 !important;
        justify-content: center;
      }

      .news_sub_time_full {
        font-size: 2.8rem;
      }

      .news_sub_time_short {
        font-size: 0.9rem;
      }

      .news_sub_text {
        margin-left: 2rem !important;
        margin-bottom: 0 !important;
        justify-content: center !important;

        .news_sub_title {
          font-size: 1.4rem !important;
          line-height: 1.5 !important;
          margin: 0 0 0.8rem 0 !important;
        }

        .news_sub_content {
          font-size: 0.9rem !important;
          line-height: 1.5 !important;
          margin: 0 0 0.8rem 0 !important;
        }
      }
    }

    .top_div {
      width: 35%;
      height: 8rem !important;
    }

    .img_div {
      width: 100% !important;
      height: 100% !important;
      border-radius: 1rem;
    }
  }

  .page_div {
    margin: 5rem 0;
  }
}
</style>
